import {useEffect} from "react";

import {useNavigationBlocker} from "@/lib/hooks/useNavigationBlocker.tsx";
import {AnalyzerEntryScreen} from "@/pages/analyzer/components/AnalyzerEntryScreen.tsx";
import {AnalyzerResultsSection} from "@/pages/analyzer/components/AnalyzerResultsSection.tsx";
import {AnalyzerChatPanel} from "@/pages/analyzer/components/chat/AnalyzerChatPanel.tsx";
import {useAnalyzerContext} from "@/pages/analyzer/hooks/AnalyzerContext.tsx";

import styles from "./AnalyzerPage.module.scss";

export const AnalyzerPageContent = () => {
  const {abort, isActive, creationOutcome} = useAnalyzerContext();
  const isCreationComplete = !!creationOutcome && Object.keys(creationOutcome.errorsByProposalId).length === 0;
  const {NavigationBlockerModal} = useNavigationBlocker({
    shouldBlock: isActive && !isCreationComplete,
    onConfirm: abort,
  });

  useEffect(() => {
    return () => {
      abort();
    };
  }, [abort]);

  return (
    <>
      {isActive ? (
        <div className={styles.split}>
          <AnalyzerChatPanel />
          <div className={styles.results}>
            <AnalyzerResultsSection />
          </div>
        </div>
      ) : (
        <div className={styles.entryScroll}>
          <AnalyzerEntryScreen />
        </div>
      )}
      <NavigationBlockerModal />
    </>
  );
};
